/**
 * PublicLanguageSelect - compact language dropdown for PUBLIC pages
 * (landing /, /features) so visitors can switch language before sign-in.
 *
 * Native <select> for accessibility + mobile ergonomics; options show
 * native names (English / 日本語 / ไทย) so the control stays readable even
 * when the current language is wrong. Authenticated app uses the full
 * LanguageCard in Settings -> Appearance instead.
 */

import { useLanguage, LANGUAGES } from '@/i18n';
import './PublicLanguageSelect.css';

export function PublicLanguageSelect() {
  const { t, language, setLanguage } = useLanguage();

  return (
    <label className="public-lang-select" aria-label={t('settings.language.title')}>
      <svg
        className="public-lang-icon"
        width="15"
        height="15"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="2" y1="12" x2="22" y2="12" />
        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
      </svg>
      <select
        className="public-lang-dropdown"
        value={language}
        onChange={(e) => setLanguage(e.target.value)}
      >
        {LANGUAGES.map((l) => (
          <option key={l.code} value={l.code}>
            {l.nativeName}
          </option>
        ))}
      </select>
    </label>
  );
}
